const AppConstants = {
  limit: 25,
};

// Define constants for order statuses with colors
const orderStatus = {
  1: { label: "Pending", color: "#F6B737" }, // Example color for Pending
  2: { label: "Confirm", color: "#02C94F" }, // Example color for Confirm
  3: { label: "Shipped", color: "#0275d8" }, // Example color for Shipped
  4: { label: "Delivered", color: "#02C94F" }, // Example color for Delivered
  5: { label: "Dispatched", color: "#d9534f" }, // Example color for Dispatched
  6: { label: "Cancel", color: "#d9534f" }, // Example color for Cancel
};

const userStatus = {
  1: { label: "Pending", color: "#F6B737" },
  2: { label: "Registered", color: "#0275d8" }, // Example color for Confirm
  3: { label: "Active", color: "#02C94F" }, // Example color for Shipped
  4: { label: "Inactive", color: "#FF0000" },
};

const transportStatus = {
  1: { label: "Pending", color: "#F6B737" },
  2: { label: "Active", color: "#02C94F" },
  3: { label: "Inactive", color: "#ff0000" },
};
// src/constants/productStatus.js

const productStatus = {
  IN_STOCK: {
    label: "In Stock",
    color: "#4CAF50", // Green for in-stock
  },
  OUT_OF_STOCK: {
    label: "Out of Stock",
    color: "#f0ad4e", // Red for out-of-stock
  },
};

const fileDriveName = {
  Product: "Product",
};

const DateFormats = {
  Default: "YYYY-MM-DD",
  DayMonthYear: "DD-MM-YYYY",
  MonthDayYear: "MM-DD-YYYY",
  MonthDayYearWithSlash: "DD/MM/YYYY",
  DayMonth: "DD MMMM",
  Day_Month_Year: "DD MMM YYYY",
  DayDateMonthYear: "dddd, DD MMMM YYYY",
  MonthYear: "MM YYYY",
  MonthYearFull: "MMM YYYY",
  LongMonthDatYear: "MMMM D, YYYY",
  ShortMonthDatYear: "MMM Do, YYYY",
  ShortMonthDatYearWithDot: "MMM. Do YYYY",
  LongMonthDateYear: "MMMM Do, YYYY",
  ShortMonthDate: "MMM Do",
  ShortMonthDatYearWithoutComma: "MMM Do YYYY",
  DayMonthDateYear: "ddd, MMM D, YYYY",
  SimpleShortMonthDatYear: "MMM D, YYYY",
  OnlyDate: "DD",
  OnlyMonth: "MMM",
  MonthDate: "MMM Do",
  OnlyDay: "ddd",
  OnlyYear: "YYYY", // Corrected from 'yyy' to 'YYYY'
  YearMonthDateTimeSecond: "YYYY-MM-DDTHH:mm:ss.SSS[Z]",
};

const BASE_URL = ``;

// Define page slugs
const pageSlug = {
  aboutUs: "about-us",
  contactUs: "contact-us",
  partners: "partners",
  termsCondition: "terms-conditions",
  privacyPolicy: "privacy-policy",
};

export {
  AppConstants,
  orderStatus,
  transportStatus,
  userStatus,
  productStatus,
  fileDriveName,
  BASE_URL,
  pageSlug, // Exported the pageSlug object
};
